//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CAN',
  data() {
    return {
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        ml: '',
        gfr: ''
      },
      gfrList: [
        { value: '0', name: 'GFR>60' },
        { value: '2', name: 'GFR=40~60' },
        { value: '4', name: 'GFR=20~39' },
        { value: '6', name: 'GFR<20' },
      ],
      hasScore: false,
      disabled: false,
      title: '',
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let num = (form.ml / 100).toFixed(0)
        let result = form.item1 * 4 + form.item2 * 3 + form.gfr + form.item3 * 5 + form.item4 * 5 + form.item5 * 5 + form.item6 * 5 + num * 1
        if (result <= 5) {
          self.title = '低危'
          self.text = '造影剂肾病发生率7.5%,预计透析风险0.04%'
        } else if (result >= 6 && result <= 10) {
          self.title = '中危'
          self.text = '造影剂肾病发生率14%,预计透析风险0.12%'
        } else if (result >= 11 && result <= 16) {
          self.title = '高危'
          self.text = '造影剂肾病发生率26.1%,预计透析风险1.09%'
        } else if (result > 16) {
          self.title = '极高危'
          self.text = '造影剂肾病发生率57.3%,预计透析风险12.6%'
        }
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/CAN.vue